import styled from 'styled-components';

export const Container = styled.div`
  min-height: 25rem;
  max-width: 30rem;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  flex-direction: column;
  text-align: center;

  img {
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 2rem;
    font-weight: 900;
    margin-top: 0.8rem;
  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  li {
    color: var(--primary_color);
    font-size: 1.4rem;
    font-weight: 700;
  }

  li:first-child {
    margin-top: 1rem;
  }

  .group-buttons {
    display: flex;
    gap: 1rem;
    margin-top: 3rem;

    button {
      font-size: 1.4rem;
      min-width: 7rem;
      text-transform: none;
      padding: 0.4rem 0.6rem;
      border: 0.1rem solid var(--primary_color);
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: 20rem;
    min-height: 15rem;

    li {
      font-size: 1.2rem;
    }

    .icon {
      width: 100%;
      max-width: 4rem;
      height: 100%;
      max-height: 4rem;
    }
  }

  @media (max-width: 580px) {
    li {
      font-size: 1rem;
      padding: 0 1rem;
    }
  }

  @media (max-width: 300px) {
    padding: 2.2rem 0 0 0;
    min-width: 15rem;
  }
`;
